import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Anchor, Box, Heading, Grid, Spinner, Text } from 'wt-ui';
import { Link as LinkIcon } from 'grommet-icons';
import i18next from '../../translations/i18n';
import API from '../../services/API';
import heap from '../../containers/App/heap';

const formatDate = (dt) => {
  let aux = dt;
  if (typeof aux === 'string') {
    aux = new Date(aux);
  }

  const monthNames = i18next.t('Months');
  const date = `${aux.getDate() < 10 ? `0${aux.getDate()}` : aux.getDate()}`;
  const monthName = `${JSON.parse(monthNames)[aux.getMonth()]}`;
  const fullYear = `${aux.getFullYear()}`;

  return `${date} ${monthName} ${fullYear}`;
};

const UpcomingEvents = (props) => {
  const [loading, setLoading] = useState(true);
  const [events, setEvents] = useState([]);
  const { underlying } = props;

  const loadEvents = async () => {
    const response = await API.getUpcomingEvents(underlying);
    // filter long products only - we have to use both names and leverage factor as fallback until leverage factor value are fixed across all products
    if (response.length > 0) {
      const resultEvents = response.map((e) => e);
      setEvents(resultEvents);
    }
    setLoading(false);
  };

  useEffect(() => {
    loadEvents();
  }, []);

  if (loading) {
    return (
      <Box background="transparent" justify="center" align="center" style={{ marginTop: '40px' }}>
        <Spinner primary />
      </Box>
    );
  }

  if (events.length <= 0) {
    return <></>;
  }

  let date = null;
  return (
    <>
      <Heading level={3} secondary style={{ marginTop: '40px' }}>
        {i18next.t('UpcomingEvents')}
      </Heading>
      <Box background="transparent">
        {events.slice(0, 2).map((event) => {
          const newDate = new Date(event.dt);
          let dtContent = '';
          if (!date || date.getDate() !== newDate.getDate()) {
            dtContent = formatDate(event.dt);
            date = newDate;
          }
          return (
            <Grid key={`${event.dt}${event.name}`} columns={['135px', 'flex', '15px']}>
              <Box background="transparent">
                <Text>{dtContent}</Text>
              </Box>
              <Box background="transparent">
                <Anchor
                  href={process.env.REACT_APP_CALENDAR_URL}
                  target="_blank"
                  onClick={() => {
                    heap.track('Heatmap_ClickEventName', { name: event.name });
                  }}
                >
                  {event.name}
                </Anchor>
              </Box>
              <Box background="transparent" align="end">
                <Anchor
                  primary
                  href={process.env.REACT_APP_CALENDAR_URL}
                  target="_blank"
                  onClick={() => {
                    heap.track('Heatmap_ClickEventLink', { name: event.name });
                  }}
                >
                  <LinkIcon size="small" color="#2DCCD3" />
                </Anchor>
              </Box>
            </Grid>
          );
        })}
      </Box>
    </>
  );
};
UpcomingEvents.propTypes = {
  underlying: PropTypes.string.isRequired,
};

export default UpcomingEvents;
